import React, { useState } from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  Grid, 
} from '@mui/material';
import { 
  Storage, 
   BarChart 
} from '@mui/icons-material';

const DiskManagement = () => {
  const [disks] = useState([
    {
      id: '1',
      name: 'OS Disk',
      size: 128,
      used: 85,
      type: 'Premium SSD',
      status: 'Attached',
      mountPoint: '/'
    },
    {
      id: '2',
      name: 'Data Disk 1',
      size: 512,
      used: 245,
      type: 'Standard SSD',
      status: 'Attached',
      mountPoint: '/data'
    },
    {
      id: '3',
      name: 'Backup Disk',
      size: 1024,
      used: 156,
      type: 'Standard HDD',
      status: 'Attached',
      mountPoint: '/backup'
    }
  ]);


  const totalStorage = disks.reduce((sum, disk) => sum + disk.size, 0);
  const totalUsed = disks.reduce((sum, disk) => sum + disk.used, 0);

  return (
    <Box>
      {/* Storage Overview */}
      <Grid spacing={3} mb={4}  sx={{display:'flex', flexDirection:"row", width:'100%'}}>
        <Grid item xs={12} md={4} sx={{width:"32%",mr:2}}>
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Total Storage</Typography>
                <Storage color="primary" />
              </Box>
              <Typography variant="h4" fontWeight="bold">{totalStorage} GB</Typography>
              <Typography variant="caption" color="text.secondary">
                Across {disks.length} disks
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4} sx={{width:"32%",mr:2}}>
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Used Storage</Typography>
                <BarChart color="success" />
              </Box>
              <Typography variant="h4" fontWeight="bold" color="success.main">
                {totalUsed} GB
              </Typography>
              {/* <LinearProgress 
                variant="determinate" 
                value={(totalUsed / totalStorage) * 100} 
                sx={{ mt: 1, mb: 1 }}
              /> */}
              <Typography variant="caption" color="text.secondary">
                {((totalUsed / totalStorage) * 100).toFixed(1)}% of total capacity
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4} sx={{width:"32%",mr:2}}>
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Available</Typography>
                <Storage sx={{ color: '#9c27b0' }} />
              </Box>
              <Typography variant="h4" fontWeight="bold" sx={{ color: '#9c27b0' }}>
                {totalStorage - totalUsed} GB
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Free space remaining
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

    </Box>
  );
};

export default DiskManagement;


